module.exports = __webpack_public_path__ + "static/media/bonus.11cdda39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/bonus.svg
// module id = 613
// module chunks = 0